var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "enterItemModal",
        centered: "",
        title: _vm.$t("tab_add_item_title"),
      },
      on: { hidden: _vm.clear },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "b-form",
        { staticClass: "enter-item-form" },
        [
          _c(
            "info-row",
            {
              staticClass: "info-main-row",
              attrs: { sizing: 4, title: _vm.$t("tab_add_item_add_label") },
            },
            [
              _c(
                "b-col",
                { staticClass: "input-group", attrs: { sm: "8" } },
                [
                  _c("b-form-select", {
                    staticClass: "form-control",
                    attrs: {
                      state: _vm.fieldState.selectedItemType,
                      title: "Item Type",
                      options: _vm.selectableItems,
                      value: _vm.selectedItemType,
                      required: "",
                    },
                    on: { change: _vm.populateInfo },
                    model: {
                      value: _vm.selectedItemType,
                      callback: function ($$v) {
                        _vm.selectedItemType = $$v
                      },
                      expression: "selectedItemType",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "info-row",
            {
              staticClass: "info-main-row",
              attrs: { sizing: 4, title: _vm.$t("tab_add_item_cost_label") },
            },
            [
              _vm.show
                ? _c("currency-input", {
                    ref: "costInput",
                    attrs: {
                      disabled: "",
                      name: "Cost",
                      amount: _vm.amount,
                      fieldState: _vm.fieldState.amount,
                    },
                    on: {
                      "update:amount": function ($event) {
                        _vm.amount = $event
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "info-row",
            {
              staticClass: "info-main-row",
              attrs: {
                sizing: 4,
                title: _vm.$t("tab_add_item_description_label"),
              },
            },
            [
              _c(
                "b-col",
                { staticClass: "input-group bill-field", attrs: { sm: "8" } },
                [
                  _c("b-form-input", {
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      title: "description",
                      min: "0",
                      state: _vm.fieldState.description,
                      value: _vm.description,
                      required: "",
                    },
                    model: {
                      value: _vm.description,
                      callback: function ($$v) {
                        _vm.description = $$v
                      },
                      expression: "description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer",
        },
        [
          _c("span", { staticClass: "text-danger" }, [
            _vm._v(_vm._s(_vm.warningText)),
          ]),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              staticClass: "float-right",
              attrs: { variant: "success" },
              on: {
                click: function ($event) {
                  return _vm.triggerItem()
                },
              },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("tab_add_item_button")) + "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }